import { makeStyles } from '@mui/styles';
import FileInput from 'apollo-react/components/FileInput';
import Loader from 'apollo-react/components/Loader';
import Modal from 'apollo-react/components/Modal';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { handleErrors } from '../../actions/ErrorActions';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { getImportTypeLabel } from '../../utils/entitiesListUtils';

const useStyles = makeStyles({
  modal: {
    width: 500,
  },
});

const ImportFileModal = ({ open, onClose, importFile, dashboardType, validateXml }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const translateString = useTranslation();
  const [isImporting, setIsImporting] = useState();

  const [file, setFile] = useState();
  const [xml, setXml] = useState();

  const importTypeLabel = getImportTypeLabel(dashboardType);

  useEffect(() => {
    if (!open) {
      setFile();
      setXml();
      setIsImporting(false);
    }
  }, [open]);

  const handleFileChange = (file) => {
    if (!file) {
      return;
    }

    const reader = new FileReader();

    reader.onload = function(e) {
      const content = e.target.result;
      setXml(content);

      file = null;
    };

    reader.readAsText(file);
    setFile(file);
  };

  const handleSave = async () => {
    try {
      validateXml({ xml, errorMessage: translateString('Invalid Import File Format') });

      setIsImporting(true);
      await importFile(file);
    } catch (error) {
      dispatch(handleErrors(error));
      onClose();
    }
  };

  return (
    <Modal
      open={open}
      variant="default"
      onClose={onClose}
      title={translateString(`Import ${importTypeLabel}`)}
      buttonProps={[
        {
          label: translateString('Cancel'),
          'ui-ta': 'ImportFileModal-CancelButton',
        },
        {
          label: translateString('Import'),
          onClick: handleSave,
          disabled: !file,
          'ui-ta': 'ImportFileModal-ImportButton',
        },
      ]}
      className={classes.modal}
      disableBackdropClick
      disableEscapeKeyDown
    >
      <FileInput
        fullWidth
        label={`${translateString('Click Browse to select a file')}.`}
        buttonText={translateString('Browse')}
        placeholder={translateString(`Choose ${importTypeLabel} to Import`)}
        accept="text/xml"
        onChange={handleFileChange}
      />
      {isImporting && <Loader isInner />}
    </Modal>
  );
};

export default ImportFileModal;
